export default "__VITE_ASSET__BZ0oQ9SD__"